<!--
 * @Author: wanghui@ykccn.com
 * @Date: 2023-02-14
 * @Description: 营销管理/平台营销工具/平台卡券活动/售卡
-->
<template>
  <scroll-layout>
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageButtons"
          :key="button.id || index"
          v-bind="button"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
    </template>
    <div>
      <ykc-detail :titles="['活动信息']" :className="'all'">
        <div slot="cvBody">
          <div class="form-detail">
            <ykc-form :label-position="'left'" label-width="90px">
              <ykc-detail-item label="活动名称：">
                <span>{{ dealData(detail.activityName) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="对外名称：">
                <span>{{ dealData(detail.outName) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动简介：">
                <span class="text-wrap">{{ dealData(detail.activityDesc) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动类型：">
                <span>售卡活动</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动状态：">
                <span>{{ statusLabel(detail.activityStatus) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动时间：">
                <span>
                  {{ dealData(detail.activityBeginTime) }} ~{{ dealData(detail.activityEndTime) }}
                </span>
              </ykc-detail-item>
              <ykc-detail-item label="修改时间：">
                <span>{{ dealData(detail.modifiedTime) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="修改人：">
                <span>{{ dealData(detail.modifiedBy) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="创建时间：">
                <span>{{ dealData(detail.createdTime) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="创建人：">
                <span>{{ dealData(detail.createdBy) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动说明：">
                <span class="text-wrap">{{ dealData(detail.activityRemark) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动范围：">
                <span>{{ dealData(detail.scopeType) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="小程序链接：">
                {{ dealData(`/pagesMyCenter/saleCard/SaleCard?activityId=${detail.activityId}`) }}
                <span
                  class="copy"
                  @click="
                    copyActivity(`/pagesMyCenter/saleCard/SaleCard?activityId=${detail.activityId}`)
                  "></span>
              </ykc-detail-item>
            </ykc-form>
          </div>
        </div>
      </ykc-detail>
      <ykc-detail :titles="['活动配置']" :className="'all'">
        <div slot="cvBody">
          <div class="form-detail">
            <ykc-form :label-position="'left'" label-width="100px">
              <ykc-detail-item label="卡券设置：">
                <ykc-table :data="detail.detailRewardInfoList" :columns="tableColumns"></ykc-table>
              </ykc-detail-item>
              <ykc-detail-item label="限制次数：">
                <span>{{ dealData(detail.limitDescribe) }}</span>
              </ykc-detail-item>
            </ykc-form>
          </div>
        </div>
      </ykc-detail>
      <ykc-detail :titles="['活动站点列表']" :className="'all'">
        <div slot="cvBody">
          <ykc-table
            ref="stationTable"
            :data="stationTableData"
            :columns="stationTableColumns">
            <ykc-pagination
              slot="pagination"
              :total="stationTabTotal"
              :pageSize.sync="stationTabPageSize"
              :currentPage="stationTabCurrentPage"
              @size-change="handleStationTabSizeChange"
              @current-change="handleStationTabCurrentChange" />
          </ykc-table>
        </div>
      </ykc-detail>
    </div>
  </scroll-layout>
</template>

<script>
  import { couponActivity } from '@/service/apis';

  export default {
    props: {
      activityId: {
        type: String,
      },
    },
    data() {
      return {
        pageButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
        name: 'SaleDetail',
        detail: {},
        tableColumns: [
          {
            label: '梯度名称',
            prop: 'groupName',
            width: 200,
          },
          {
            label: '购买金额',
            prop: 'salePrice',
            width: 240,
          },
          {
            label: '赠送卡券',
            prop: 'cardCouponName',
            width: 240,
            scopedSlots: {
              default: ({ row }) => {
                if (row.rewardType === 1 || row.rewardType === 2) {
                  return (
                    <el-link type="primary" onClick={() => this.handleCellClick(row)}>
                      {row.cardCouponName}
                    </el-link>
                  );
                }
                return <span>{row.cardCouponName}</span>;
              },
            },
          },
          { label: '发送数量(张/人)', prop: 'num', width: 240 },
          { label: '特价金额', prop: 'specialPrice', width: 240 },
          { label: '特价库存', prop: 'surplusCount', width: 240 },
        ],
        stationTableData: [],
        stationTableColumns: [
          { label: '电站编码', prop: 'dataId', minWidth: '150px' },
          { label: '电站名称', prop: 'dataName', minWidth: '150px' },
          { label: '电站类型', prop: 'stationTypeText', minWidth: '150px' },
          { label: '归属商户', prop: 'stationOperatorName', minWidth: '150px' },
        ],
        stationTabTotal: 0,
        stationTabPageSize: 10,
        stationTabCurrentPage: 1,
      };
    },
    computed: {},
    created() {
      this.getDetail();
    },
    methods: {
      dicStatus() {
        // 活动状态（1:进行中，2:未开始，3:已结束(手动停用)，4:已结束(活动到期)，5:已结束(卡券不足)，6:已结束(卡券失效)）
        return [
          { id: '1', name: '进行中' },
          { id: '2', name: '未开始' },
          { id: '3', name: '已结束(手动停用)' },
          { id: '4', name: '已结束(活动到期)' },
          { id: '5', name: '已结束(卡券不足)' },
          { id: '6', name: '已结束(卡券失效)' },
        ];
      },

      handleCellClick(row) {
        if (row.rewardType === 1) {
          const routeUrl = this.$router.resolve({
            path: '/marketingCenter/platformMarketingTools/platformCoupon/creditCard',
            query: {
              data: row.rewardId,
            },
          });
          window.open(routeUrl.href, '_blank');
        } else if (row.rewardType === 2) {
          const routeUrl = this.$router.resolve({
            path: '/marketingCenter/platformMarketingTools/platformCoupon/coupon',
            query: {
              data: row.rewardId,
            },
          });
          window.open(routeUrl.href, '_blank');
        }
      },
      statusLabel(status) {
        if (!status) {
          return '——';
        }
        const obj = this.dicStatus()?.find(item => item.id === status);
        return obj?.name || '——';
      },
      /**
       * 获取详情数据
       */
      getDetail() {
        couponActivity.saleActivityDetail({ activityId: this.activityId }).then(res => {
          if (res) {
            this.detail = res || {};
            this.getStations();
          }
        });
      },
      /**
       * 获取活动站点列表
       */
      getStations() {
        couponActivity
          .saleActivityStations({
            activityId: this.activityId,
            current: this.stationTabCurrentPage,
            size: this.stationTabPageSize,
          })
          .then(res => {
            if (res) {
              this.stationTableData = res?.records || [];
              this.stationTabTotal = res?.total || 0;
            }
          });
      },
      handleStationTabSizeChange(size) {
        this.stationTabPageSize = size;
        this.getStations();
      },
      handleStationTabCurrentChange(currentPage) {
        this.stationTabCurrentPage = currentPage;
        this.getStations();
      },
      dealData(data) {
        return data || '—';
      },
      copyActivity(str) {
        this.$copyText(str)
          .then((e, err) => {
            if (e) {
              this.$message.success('复制成功');
            }
            if (err) {
              this.$message.error('复制失败');
            }
          })
          .catch(error => {
            console.log('error', error);
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .text-wrap {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .all {
    margin-bottom: 16px;
  }
  .ykc-tree.detailTree {
    padding-top: 0;
  }
  .copy {
    margin-left: 6px;
    width: 14px;
    cursor: pointer;
    background: url('~@/assets/images/staging/copy.png') no-repeat 100%;
  }
</style>
